import { useFitnessStore } from '../store/fitnessStore';

const ACCESS_MAP = {
  unlimited_exercises: ['pro', 'elite'],
  ai_plan_generator: ['pro', 'elite'],
  sport_plans: ['pro', 'elite'],
  nutrition_logging: ['pro', 'elite'],
  progress_90day: ['pro', 'elite'],
  coach_extended: ['pro', 'elite'],
  ai_meal_plans: ['elite'],
  ai_progress_analysis: ['elite'],
  unlimited_coach: ['elite'],
  competition_mode: ['elite'],
};

export function useCanAccess(feature) {
  const profile = useFitnessStore((s) => s.profile);
  return ACCESS_MAP[feature]?.includes(profile.subscriptionTier) ?? true;
}

export function useAILimit(type) {
  const profile = useFitnessStore((s) => s.profile);
  const aiUsageToday = useFitnessStore((s) => s.aiUsageToday);
  const today = new Date().toDateString();
  const usage = aiUsageToday.date === today ? aiUsageToday : { coach: 0, plans: 0 };

  const limits = {
    free: { coach: 3, plans: 0 },
    pro: { coach: 20, plans: 3 },
    elite: { coach: 999, plans: 999 },
  };
  const limit = limits[profile.subscriptionTier]?.[type] ?? 0;
  const used = usage[type] ?? 0;
  return { canUse: used < limit, remaining: Math.max(0, limit - used), limit, used };
}
